import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { WordList } from '@thiememeulenhoff/types';
import { WordListEndpointService } from './wordlist.endpoint.service';

@Injectable({
  providedIn: 'root',
})
export class WordListService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(WordListEndpointService);

  fetchWordLists(arrangementCode: string, contentIdentifier?: string) {
    if (!arrangementCode || arrangementCode === '') {
      throw new Error('arrangementCode is required for fetching word lists');
    }

    return this.#http.get<Array<WordList>>(
      this.#endpoints.wordLists(arrangementCode),
      {
        params: contentIdentifier ? { contentIdentifier } : undefined,
      },
    );
  }

  fetchWordList(
    arrangementCode: string,
    id: string,
    contentIdentifier: string,
  ) {
    if (!arrangementCode || arrangementCode === '') {
      throw new Error('arrangementCode is required for fetching a word list');
    }

    if (!id || id === '') {
      throw new Error('id is required for fetching a word list');
    }

    return this.#http.get<WordList>(
      this.#endpoints.wordList(arrangementCode, id, contentIdentifier),
    );
  }
}
